import { Satellite } from "@material-ui/icons"

const UserReducer = (state, action = {}) => {
  const { userData, type, locationData, menuStatus, menuDrawerStatus, bookingData, centerDetails, predictionData } = action
  switch (type) {
    case 'UPDATE_USER': {
      return {
        ...state,
        user: { ...state.user, ...userData }
      }
    }
    case 'UPDATE_LOCATION': {
      return {
        ...state,
        location: { ...state.location, ...locationData }
      }
    }
    case 'SET_CENTER_DETAILS': {
      return {
        ...state,
        centerDetails: { ...state.centerDetails, ...centerDetails }
      }
    }
    case 'RESET_CENTER_DETAILS': {
      return {
        ...state,
        centerDetails: {}
      }
    }
    case 'RESET_BOOKING': {
      return {
        ...state,
        booking: {}
      }
    }
    case 'UPDATE_MENU_STATUS': {
      return {
        ...state,
        menu: menuStatus
      }
    }
    case 'UPDATE_HAMBURGER_MENU_STATUS': {
      return {
        ...state,
        hideHamburger: menuStatus
      }
    }
    case 'UPDATE_MENUDRAWER_STATUS': {
      return {
        ...state,
        menuDrawer: menuDrawerStatus
      }
    }
    case 'UPDATE_BOOKING': {
      return {
        ...state,
        booking: { ...state.booking, ...bookingData }
      }
    }
    case 'PREDICTION': {
      return {
        ...state,
        prediction: {predictionData}
      }
    }
    default:
      return state
  }
}

export default UserReducer
